export const regexPattern = {
    capture: {
        // Will capture all groups of floating-point numbers.
        // 1. Does not accept exponent notation.
        // 2. Accepts a leading `.` (no preceding digit).
        // 3. Use `[0]` to select the first group.
        float: /(\d*\.)?\d+/g,
        floatSigned: /[+-]?(\d*\.)?\d+/g,
    },
    validate: {
        email: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,22}$/g,
        // See above `capture` notes for `float*`.
        float: /^(\d*\.)?\d+$/g,
        floatSigned: /^[+-]?(\d*\.)?\d+$/g,
    },
};

// Some `eslint` and `prettier` rules need to be disabled in order
// to pass `\` escape characters to HTML attributes.
// prettier-ignore
export const htmlPattern = {
    email: '[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,22}$',
    // Identical to `regexPatterns.validate > float*`.
    float: '([0-9]*[.])?[0-9]+',
    // eslint-disable-next-line no-useless-escape
    floatSigned: '[\+\-]?([0-9]*[.])?[0-9]+',
};
